'use client';

import { useRef } from 'react';
import HeroSection from './HeroSection';
import ProcessOverview from './ProcessOverview';
import InteractiveConveyor from './InteractiveConveyor';
import ChemistryProtocols from './ChemistryProtocols';
import QualityCheckpoints from './QualityCheckpoints';
import ColorCapabilities from './ColorCapabilities';
import PerformanceData from './PerformanceData';
import CTASection from './CTASection';
import PowderCoatingProcessShowcase from './PowderCoatingProcessShowcase';

const PowderCoatingInteractive = () => {
  const processRef = useRef<HTMLDivElement>(null);

  const scrollToProcess = () => {
    processRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      <HeroSection onScrollToProcess={scrollToProcess} />
      <div ref={processRef}>
        <ProcessOverview />
      </div>
      <InteractiveConveyor />
      <ChemistryProtocols />
      <QualityCheckpoints />
      <PowderCoatingProcessShowcase />
      <ColorCapabilities />
      <PerformanceData />
      <CTASection />
    </>
  );
};

export default PowderCoatingInteractive;